import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'relative 2xl:max-w-[172rem] 2xl:mx-auto pt-5 md:pt-7 before:absolute before:top-0 before:left-2 before:w-[calc(100%-4rem)] md:before:left-4 md:before:w-[calc(100%-8rem)] before:h-[1.5px] before:bg-black',
		wrapper: 'px-2 md:px-4 mt-2 grid grid-cols-4 md:grid-cols-6 gap-2 lg:gap-4',
		imageContainer: 'relative w-full overflow-hidden col-span-4 lg:col-span-4 aspect-[3/2] rounded-xs md:rounded-m',
		image: 'absolute top-0 left-0 object-cover w-full h-full',
		list: 'col-span-4 md:col-span-2 divide-y-[1.5px]',
		itemStyle: 'relative py-2 cursor-pointer group [&:first-child]:pt-0 transition-border duration-300',
		headline: 'group-hover:text-mainPink group-focus:text-mainPink transition-color duration-300'
	},
})

export type ImageListVariants = VariantProps<typeof styles>
